/**
 * DC 프로덕트 (sections/dc-products.liquid), homepage on PC only
 * (.dc-products--slider; on mobile and on the Products page the cards
 * stack in a grid instead): the product cards are a horizontal scroll-snap
 * strip showing 2 at a time; with more than 2 it slides. Touch/trackpad scroll works on its own; this adds prev/next
 * arrows (hidden at each end, and entirely when everything fits) that
 * scroll by one card, vertically centered on the card images.
 *
 * Autoplay (section settings 자동 슬라이드 on/off + 간격, passed as
 * data-autoplay / data-autoplay-seconds): when there are more cards than
 * fit, it advances one card every interval and returns to the start after
 * the last one. It pauses while
 * the pointer is over the strip, while it has focus, for a while after the
 * shopper swipes or clicks an arrow, while the section is off screen, and
 * not at all for "reduce motion" users.
 */
(() => {
  // Figma 833:1918 / 833:2209 arrow icon (25px chevron).
  const CHEVRON =
    '<svg viewBox="0 0 25 25" fill="none" aria-hidden="true">' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 20.1751L15.1743 12.5007L7.5 4.8264L8.66284 3.66356L17.5 12.5007L8.66284 21.3379L7.5 20.1751Z" fill="currentColor"/></svg>';

  const DEFAULT_SECONDS = 5;
  const RESUME_AFTER_MS = 8000;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(slider) {
    if (slider.dataset.dcSlider) return;
    const strip = slider.querySelector('.dc-products__product-grid');
    if (!strip) return;
    slider.dataset.dcSlider = 'true';

    const make = (dir) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'dc-products__arrow dc-products__arrow--' + dir;
      button.setAttribute('aria-label', dir === 'prev' ? '前へ' : '次へ');
      button.innerHTML = CHEVRON;
      if (dir === 'prev') button.querySelector('svg').style.transform = 'scaleX(-1)';
      button.addEventListener('click', () => {
        const item = strip.firstElementChild;
        const gap = parseFloat(getComputedStyle(strip).columnGap) || 0;
        const step = item ? item.getBoundingClientRect().width + gap : strip.clientWidth;
        strip.scrollBy({ left: dir === 'prev' ? -step : step, behavior: 'smooth' });
      });
      slider.appendChild(button);
      return button;
    };
    const prev = make('prev');
    const next = make('next');

    // ---- autoplay ----
    let hovering = false;
    let focused = false;
    let visible = false;
    let pausedUntil = 0;

    const step = () => {
      const item = strip.firstElementChild;
      const gap = parseFloat(getComputedStyle(strip).columnGap) || 0;
      return item ? item.getBoundingClientRect().width + gap : strip.clientWidth;
    };
    const overflows = () => strip.scrollWidth > strip.clientWidth + 1;
    const atEnd = () => strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 1;

    const tick = () => {
      if (reduceMotion || !visible || hovering || focused || Date.now() < pausedUntil || !overflows()) return;
      if (atEnd()) strip.scrollTo({ left: 0, behavior: 'smooth' });
      else strip.scrollBy({ left: step(), behavior: 'smooth' });
    };
    if (slider.dataset.autoplay !== 'false') {
      const seconds = parseFloat(slider.dataset.autoplaySeconds) || DEFAULT_SECONDS;
      setInterval(tick, seconds * 1000);
    }

    const pause = () => {
      pausedUntil = Date.now() + RESUME_AFTER_MS;
    };
    slider.addEventListener('mouseenter', () => (hovering = true));
    slider.addEventListener('mouseleave', () => (hovering = false));
    slider.addEventListener('focusin', () => (focused = true));
    slider.addEventListener('focusout', () => (focused = false));
    strip.addEventListener('touchstart', pause, { passive: true });
    strip.addEventListener('wheel', pause, { passive: true });
    prev.addEventListener('click', pause);
    next.addEventListener('click', pause);
    new IntersectionObserver((entries) => {
      visible = entries[0].isIntersecting;
    }).observe(strip);

    const update = () => {
      const media = strip.querySelector('.dc-product-card__media');
      if (media) {
        const top = strip.offsetTop + media.getBoundingClientRect().height / 2;
        prev.style.top = next.style.top = top + 'px';
      }
      prev.hidden = strip.scrollLeft <= 1;
      next.hidden = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 1;
    };
    strip.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init() {
    document.querySelectorAll('.dc-products--slider .dc-products__slider').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Theme editor: sections re-render in place.
  document.addEventListener('shopify:section:load', init);
})();
